import apiService from './apiService';

// ==================== HV Work Permit CRUD operations ====================

export const createHVWorkPermit = async (payload: any) => {
  try {
    const response = await apiService.post('/hv-work-permits', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating HV work permit:', error);
    throw error;
  }
};

// UPDATED: accepts search param
export const getHVWorkPermits = async (page: number = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      page: String(page),
    });

    // correct query format: filter[search]
    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/hv-work-permits?${params.toString()}`); // FIXED: was `?page=${page}`, now uses params
    return response.data;
  } catch (error) {
    console.error('Error fetching HV work permits:', error);
    throw error;
  }
};

export const getHVWorkPermitById = async (id: number | string) => {
  try {
    const response = await apiService.get(`/hv-work-permits/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching HV work permit by ID:', error);
    throw error;
  }
};

export const updateHVWorkPermit = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/hv-work-permits/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating HV work permit:', error);
    throw error;
  }
};

export const updateHVWorkPermitDraft = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/hv-work-permits/${id}/draft`, payload);
    return response.data;
  } catch (error) {
    console.error('Error saving HV work permit draft:', error);
    throw error;
  }
};

export const deleteHVWorkPermit = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/hv-work-permits/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting HV work permit:', error);
    throw error;
  }
};

// ==================== Isolations operations ====================

export const saveIsolations = async (payload: any) => {
  try {
    const response = await apiService.post('/hvwp-isolations', payload);
    return response.data;
  } catch (error) {
    console.error('Error saving isolations:', error);
    throw error;
  }
};

export const getIsolations = async (permitId?: number | string) => {
  try {
    const url = permitId ? `/hvwp-isolations?hv_work_permit_id=${permitId}` : '/hvwp-isolations';
    const response = await apiService.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching isolations:', error);
    throw error;
  }
};

export const getIsolationById = async (id: number | string) => {
  try {
    const response = await apiService.get(`/hvwp-isolations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching isolation by ID:', error);
    throw error;
  }
};

export const updateIsolation = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/hvwp-isolations/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating isolation:', error);
    throw error;
  }
};

// ==================== Earths operations ====================

export const saveEarths = async (payload: any) => {
  try {
    const response = await apiService.post('/hvwp-earths', payload);
    return response.data;
  } catch (error) {
    console.error('Error saving earths:', error);
    throw error;
  }
};

export const getEarths = async (permitId?: number | string) => {
  try {
    const url = permitId ? `/hvwp-earths?hv_work_permit_id=${permitId}` : '/hvwp-earths';
    const response = await apiService.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching earths:', error);
    throw error;
  }
};

export const getEarthById = async (id: number | string) => {
  try {
    const response = await apiService.get(`/hvwp-earths/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching earth by ID:', error);
    throw error;
  }
};

export const updateEarth = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/hvwp-earths/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating earth:', error);
    throw error;
  }
};

// ==================== Responsible Persons operations ====================

export const getResponsiblePersons = async () => {
  try {
    const response = await apiService.get('/hvwp-responsible-persons');
    return response.data;
  } catch (error) {
    console.error('Error fetching responsible persons:', error);
    throw error;
  }
};

// ==================== Signature operations ====================

export const saveSignature = async (payload: any) => {
  try {
    const response = await apiService.post('/hvwp-signatures', payload);
    return response.data;
  } catch (error) {
    console.error('Error saving signature:', error);
    throw error;
  }
};

export const getSignatures = async (permitId?: number | string) => {
  try {
    const url = permitId ? `/hvwp-signatures?hv_work_permit_id=${permitId}` : '/hvwp-signatures';
    const response = await apiService.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching signatures:', error);
    throw error;
  }
};

export const getSignatureById = async (id: number | string) => {
  try {
    const response = await apiService.get(`/hvwp-signatures/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching signature by ID:', error);
    throw error;
  }
};

export const updateSignature = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/hvwp-signatures/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating signature:', error);
    throw error;
  }
};

export const getAppointedOPerators = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=4');
    return response.data;
  } catch (error) {
    console.error('Error fetching Appointed Operators:', error);
    throw error;
  }
};

export const notifyIsolation = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/notify-isolation`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying isolation:', error);
    throw error;
  }
};

export const markIsolation = async (id: number | string) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/mark-isolation`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking isolation:', error);
    throw error;
  }
};

export const markPermitTakeout = async (id: number | string) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/mark-permit-takeout`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking permit takeout:', error);
    throw error;
  }
};

export const notifyIssuePermit = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/notify-issue-permit`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying issue permit:', error);
    throw error;
  }
};

export const markIssuePermit = async (id: number | string) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/mark-issue-permit`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking issue permit:', error);
    throw error;
  }
};

export const notifyRPChange = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/notify-rp-change`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying RP change:', error);
    throw error;
  }
};

export const markRPChange = async (id: number | string) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/mark-rp-changed`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking RP change:', error);
    throw error;
  }
};

export const markClearance = async (id: number | string) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/mark-rp-cleared`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking clearance:', error);
    throw error;
  }
};

export const notifyClearance = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/notify-aoc-clearance`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying clearance:', error);
    throw error;
  }
};

export const markAoClearance = async (id: number | string) => {
  try {
    const response = await apiService.post(`/hv-work-permits/${id}/mark-aoc-cleared`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking clearance:', error);
    throw error;
  }
};
export const getHVWorkPermitDownload = async (id: string | number) => {
  try {
    const response = await apiService.get(`hv-work-permits/${id}/download`, {
      responseType: 'blob',
    });
    return response.data; // Blob
  } catch (error) {
    console.error('Error downloading hv-work-permit:', error);
    throw error;
  }
};
